<template>
  <div>
    <el-row v-show="isFunNowEnable && isFunBookV2Enable && !isYCMode">
      <el-button
        :type="cancelRulePlatformBtnType === platformBtnFocusType.funnow ? 'primary' : ''"
        @click="focusShowOnTypeBtn(platformBtnFocusType.funnow)"
      >
        {{ $t('api.product.show_on_type_btn.funnow_group') }}
      </el-button>
      <el-button
        :type="cancelRulePlatformBtnType === platformBtnFocusType.funbook ? 'primary' : ''"
        @click="focusShowOnTypeBtn(platformBtnFocusType.funbook)"
      >
        {{ $t('api.product.show_on_type_btn.funnow_booking') }}
      </el-button>
    </el-row>
    <el-row :gutter="20"
      v-show="isFunNowRuleEnable"
    >
      <el-col :xs="24">
        <el-form-item
          :label="$t(`api.optFields.cancelType.${isYCMode ? 'yc_' : ''}label`)"
        >
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20"
      v-show="formData.cancel_type === 2 && isFunNowRuleEnable && !isYCMode && !isFunNowSeatOnly"
    >
      <el-col :xs="24">
        <el-form-item
          :label="$t('api.product.fields.cancel_rule.default.label')"
        >
          <el-button
            class="tmpl-btn"
            v-for="(r, idx) in defRules"
            :key="idx"
            @click="() => onApply(r)"
          >
            {{ r.name }}
          </el-button>
        </el-form-item>
        <el-divider></el-divider>
      </el-col>
    </el-row>
    <reschedule-setting
      v-show="formData.cancel_type === 2 && isFunNowRuleEnable"
      ref="rescheduleSetting"
      @ruleChange="onRescheduleChange"
      :formData="formData"
      :showSetting="formData.reschedulable === 1"
    >
      <template #beforeSetting>
        <el-row :gutter="20">
          <el-col :xs="24">
            <std-opt
              v-model="formData.reschedulable"
              :isForm="true"
              name="reschedulable"
              component="radio-button"
            >
            </std-opt>
          </el-col>
        </el-row>
      </template>
    </reschedule-setting>
    <el-row :gutter="20" v-if="formData.cancel_type === 2 && isFunNowRuleEnable">
      <el-col :xs="24">
        <el-form-item
          :label="$t('api.product.fields.reschedule_rule.preview')"
        >
          <el-alert
            type="info"
            :closable="false"
          >
            <ul class="preview">
              <li
                v-for="(line, idx) in previewRescheduleRule"
                :key="idx"
              >
                {{ line }}
              </li>
            </ul>
          </el-alert>
        </el-form-item>
      </el-col>
    </el-row>
    <cancel-setting
      v-show="formData.cancel_type === 2 && isFunNowRuleEnable"
      ref="cancelSetting"
      @ruleChange="onCancelChange"
      :showSetting="formData.cancelable === 1"
      :formData="formData"
      :limitOne="isYCMode || isSeatOnlyAndPayOnsite"
      :isNoShowPenalty="isNoShowPenalty"
    >
      <template #beforeSetting>
        <el-row :gutter="20">
          <el-col :xs="24">
            <std-opt
              v-model="formData.cancelable"
              :isForm="true"
              name="cancelable"
              component="radio-button"
              :disabled="cancelableDisabled"
            >
            </std-opt>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="!isYCMode">
          <el-col :xs="24">
            <std-opt
              v-model="formData.cooling_off"
              :isForm="true"
              name="coolingOff"
              component="radio-button"
              :disabled="formData.cancelable === 0 || isSeatOnlyAndPayOnsite"
            >
            </std-opt>
          </el-col>
          <el-col :xs="24">
            <std-opt
              v-model="formData.no_show_penalty"
              :isForm="true"
              name="noShowPenalty"
              component="radio-button"
              :disabled="formData.cancelable === 0 || !isSeatOnlyAndPayOnsite"
            >
            </std-opt>
          </el-col>
        </el-row>
      </template>
    </cancel-setting>
    <el-row :gutter="20"
      v-show="formData.cancel_type !== 2 && isFunNowRuleEnable"
    >
      <el-col :xs="24" :md="12">
        <std-opt
          v-model="formData.cancelable"
          :isForm="true"
          name="cancelable"
          component="radio-button"
          :disabled="cancelableDisabled"
        >
        </std-opt>
      </el-col>
    </el-row>
    <el-row :gutter="20"
      v-if="isFunNowRuleEnable"
    >
      <el-col :xs="24">
        <text-field
          v-model="formData.cancel_rule"
          :base="base"
          name="cancel_rule"
          type="textarea"
          :hasTrans="true"
          :show-auto-translate="true"
          :oriData="oriData"
          :transData="transData"
          :required="cancelRuleRequired"
          :grammar-config="getGrammarConfig('cancel_rule')"
          :placeholderText="$t('placeholder_content_format_hint', { field_name: getLabelText(base, 'cancel_rule') })"
        >
        </text-field>
      </el-col>
    </el-row>
    <el-row :gutter="20"
      v-if="isFunNowRuleEnable"
    >
      <el-col :xs="24">
        <el-form-item
          :label="$t('api.product.fields.cancel_rule.preview')"
        >
          <el-alert
            type="info"
            :closable="false"
          >
            <ul class="preview">
              <li
                v-for="(line, idx) in previewCancelRule"
                :key="idx"
              >
                {{ line }}
              </li>
            </ul>
          </el-alert>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20"
      v-show="isFunBookV2RuleEnable"
    >
      <el-col :xs="24">
        <std-opt
          v-model="formData.fb_cancel_type"
          :isForm="true"
          name="fbCancelType"
          component="radio-button"
          :disabled="formData.cancel_type !== 2 || !isFunNowEnable || (isSeatOnlyAndPayOnsite && isFunNowAndFunBook)"
        >
        </std-opt>
      </el-col>
      <el-col :xs="24"
        v-if="formData.fb_cancel_type == 1 && isPaymentOnline && isFunNowEnable"
      >
        <el-button
          icon="el-icon-plus"
          @click="onCopy"
        >
          {{ $t('api.product.fields.cancel_rule.copy.name') }}
        </el-button>
      </el-col>
    </el-row>
    <reschedule-setting
      v-show="formData.fb_cancel_type === 1 && isFunBookV2RuleEnable"
      ref="fbRescheduleSetting"
      @ruleChange="onRescheduleChange"
      :formData="formData"
      :showSetting="formData.fb_reschedulable === 1"
      :isFunBook="true"
    >
      <template #beforeSetting>
        <el-row :gutter="20">
          <el-col :xs="24">
            <std-opt
              v-model="formData.fb_reschedulable"
              :isForm="true"
              name="reschedulable"
              component="radio-button"
            >
            </std-opt>
          </el-col>
        </el-row>
      </template>
    </reschedule-setting>
    <el-row :gutter="20"
      v-if="formData.fb_cancel_type === 1 && isFunBookV2RuleEnable"
    >
      <el-col :xs="24">
        <el-form-item
          :label="$t('api.product.fields.reschedule_rule.preview')"
        >
          <el-alert
            type="info"
            :closable="false"
          >
            <ul class="preview">
              <li
                v-for="(line, idx) in previewFBRescheduleRule"
                :key="idx"
              >
                {{ line }}
              </li>
            </ul>
          </el-alert>
        </el-form-item>
      </el-col>
    </el-row>
    <cancel-setting
      v-show="formData.fb_cancel_type === 1 && isFunBookV2RuleEnable"
      ref="fbCancelSetting"
      @ruleChange="onCancelChange"
      :showSetting="formData.fb_cancelable === 1"
      :formData="formData"
      :limitOne="isFunBookWithoutOnlinePayment"
      :isFunBook="true"
      :isNoShowPenalty="isFBNoShowPenalty"
    >
      <template #beforeSetting>
        <el-row :gutter="20">
          <el-col :xs="24" :md="12">
            <std-opt
              v-model="formData.fb_cancelable"
              :isForm="true"
              name="cancelable"
              component="radio-button"
              :disabled="cancelableDisabled"
            >
            </std-opt>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24">
            <std-opt
              v-model="formData.fb_cooling_off"
              :isForm="true"
              name="coolingOff"
              component="radio-button"
              :disabled="formData.fb_cancelable === 0"
            >
            </std-opt>
          </el-col>
          <el-col :xs="24">
            <std-opt
              v-model="formData.fb_no_show_penalty"
              :isForm="true"
              name="noShowPenalty"
              component="radio-button"
              :disabled="true"
            >
            </std-opt>
          </el-col>
        </el-row>
      </template>
    </cancel-setting>
    <el-row :gutter="20"
      v-show="isFunBookV2RuleEnable"
    >
      <el-col :xs="24">
        <text-field
          v-model="formData.fb_cancel_rule"
          :base="base"
          name="fb_cancel_rule"
          type="textarea"
          :hasTrans="true"
          :show-auto-translate="true"
          :oriData="oriData"
          :transData="transData"
          :grammar-config="getGrammarConfig('fb_cancel_rule')"
        >
        </text-field>
      </el-col>
    </el-row>
    <el-row
      :gutter="20"
      v-show="isFunBookV2RuleEnable"
    >
      <el-col :xs="24">
        <el-form-item
          :label="$t('api.product.fields.fb_cancel_rule.preview')"
        >
          <el-alert
            type="info"
            :closable="false"
          >
            <ul class="preview">
              <li
                v-for="(line, idx) in previewFBCancelRule"
                :key="idx"
              >
                {{ line }}
              </li>
            </ul>
          </el-alert>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import _ from 'lodash'
import { fetchCancelRule, fetchRescheduleRule } from '@/api/merchant/product'
import CancelSetting from './CancelSetting'
import RescheduleSetting from './RescheduleSetting'
import DefRules from '@/mixins/def_rules'
import { platformBtnFocusType } from '@/utils/platform_focus_type'
import { getLabelText } from '@/utils/i18n'
import {
  ProductSalesMode,
  ProductCoolingOff,
  ProductBookingMode,
  ProductPaymentMode,
  ProductNoShowPenalty
} from '@/enums'
import { GrammarCheckerTemplate } from '@/enums/aiRelativeTools'

export default {
  mixins: [DefRules],
  components: {
    CancelSetting,
    RescheduleSetting
  },
  name: 'cancel-rule',
  props: {
    formData: {
      type: Object,
      required: true
    },
    oriData: {
      type: Object,
      required: true
    },
    transData: {
      type: Array,
      default: () => []
    },
    upOptData: {
      type: Array,
      default: () => []
    },
    isFunBookV2Enable: {
      type: Boolean,
      default: false
    },
    isFunNowEnable: {
      type: Boolean,
      default: true
    },
    isFunNowAndFunBook: {
      type: Boolean,
      default: false
    },
    isYCMode: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      base: 'product',
      platformBtnFocusType: Object.assign({}, platformBtnFocusType),
      cancelRulePlatformBtnType: 0,
      defRules: [],
      cancelRes: [],
      fbCancelRes: [],
      rescheduleRes: [],
      fbRescheduleRes: [],
      getLabelText
    }
  },
  created () {
    this.initDefRules()
    this.onChange()
  },
  mounted () {
    if (!this.isEdit) {
      this.onApply(this.defRules[0])
    }
  },
  computed: {
    previewCancelRule () {
      return this.getPreview(this.cancelRes, 'cancel_rule')
    },
    previewFBCancelRule () {
      return this.getPreview(this.fbCancelRes, 'fb_cancel_rule')
    },
    previewRescheduleRule () {
      return this.getPreview(this.rescheduleRes, 'reschedule_rule')
    },
    previewFBRescheduleRule () {
      return this.getPreview(this.fbRescheduleRes, 'fb_reschedule_rule')
    },
    cancelableDisabled () {
      return (this.formData.sales_mode === ProductSalesMode.Delivery ||
        this.formData.sales_mode === ProductSalesMode.AlcoholDelivery
      )
    },
    cancelRuleRequired () {
      // return (this.formData.cancelable === 0 && this.formData.cancel_type !== 2)
      return false
    },
    isPaymentOnline () {
      return this.formData.setting.payment_mode === ProductPaymentMode.Online
    },
    isFunBookWithoutOnlinePayment () {
      return this.isFunBookV2Enable && this.formData.setting.payment_mode === ProductPaymentMode.Onsite
    },
    isFunBookOnlinePayment () {
      return this.isFunBookV2Enable && this.formData.setting.payment_mode === ProductPaymentMode.Online
    },
    isFunNowSeatOnly () {
      return this.isFunNowRuleEnable && this.isSeatOnlyAndPayOnsite
    },
    isSeatOnlyAndPayOnsite () {
      return this.formData.setting.payment_mode === ProductPaymentMode.Onsite &&
          this.formData.setting.booking_mode === ProductBookingMode.SeatOnly
    },
    isNoShowPenalty () {
      return this.formData.no_show_penalty === ProductNoShowPenalty.Enabled
    },
    isFBNoShowPenalty () {
      return this.formData.fb_no_show_penalty === ProductNoShowPenalty.Enabled
    },
    isFunNowRuleEnable () {
      if (this.cancelRulePlatformBtnType === this.platformBtnFocusType.notFocus) {
        return this.isFunNowEnable
      }
      return (
        this.isFunNowEnable &&
        this.cancelRulePlatformBtnType === this.platformBtnFocusType.funnow
      )
    },
    isFunBookV2RuleEnable () {
      if (this.cancelRulePlatformBtnType === this.platformBtnFocusType.notFocus) {
        return this.isFunBookV2Enable
      }

      return (
        this.isFunBookV2Enable &&
        this.cancelRulePlatformBtnType === this.platformBtnFocusType.funbook
      )
    }
  },
  methods: {
    initDefRules () {
      this.defRules = this.$_getDefaultRules()
    },
    getSetting (t) {
      switch (t) {
        case 'cancel':
          return (this.$refs.cancelSetting && this.$refs.cancelSetting.cancelRule) || {}
        case 'fb_cancel':
          return (this.$refs.fbCancelSetting && this.$refs.fbCancelSetting.cancelRule) || {}
        case 'reschedule':
          return (this.$refs.rescheduleSetting && this.$refs.rescheduleSetting.rescheduleRule) || {}
        case 'fb_reschedule':
          return (this.$refs.fbRescheduleSetting && this.$refs.fbRescheduleSetting.rescheduleRule) || {}
      }
    },
    getModeKey (m) {
      switch (m) {
        case 0:
          return 'day'
        case 1:
          return 'date'
        case 2:
          return 'hour'
      }

      return 'day'
    },
    getPreview (def, name) {
      let add = ''
      if (this.formData[name]) {
        let rule = this.formData[name]
        for (let idx in this.transData) {
          let t = this.transData[idx]
          let code = t.code
          if (code === 'ja-JP') {
            code = 'ja'
          }
          if (code === this.$store.getters.language && t[name]) {
            rule = t[name]
            break
          }
        }
        add = rule.split(/\r?\n/)
      }
      return def.concat(add).filter(e => e)
    },
    clearRules () {
      this.$refs.rescheduleSetting.clearRules()
    },
    onChange () {
      this.onCancelChange()
      this.onRescheduleChange()
    },
    onCancelChange: _.debounce(function () {
      let dataId = this.formData.id || 0
      fetchCancelRule(dataId, {
        'cancelable': this.formData.cancelable,
        'fb_cancelable': this.formData.fb_cancelable,
        'cancel_type': this.formData.cancel_type,
        'fb_cancel_type': this.formData.fb_cancel_type,
        'booking_mode': this.formData.setting.booking_mode,
        'payment_mode': this.formData.setting.payment_mode,
        'no_show_penalty': this.formData.no_show_penalty,
        'fb_no_show_penalty': this.formData.fb_no_show_penalty,
        'setting': this.getSetting('cancel'),
        'fb_setting': this.getSetting('fb_cancel'),
        'currency': this.formData.currency_code,
        'is_yc': this.isYCMode
      }).then((res) => {
        this.cancelRes = res.data.cancel_rules
        this.fbCancelRes = res.data.fb_cancel_rules
      }).catch(err => {
        console.log(err)
      })
    }, 1000),
    onRescheduleChange: _.debounce(function () {
      let dataId = this.formData.id || 0
      fetchRescheduleRule(dataId, {
        'reschedulable': this.formData.reschedulable,
        'fb_reschedulable': this.formData.fb_reschedulable,
        'booking_mode': this.formData.setting.booking_mode,
        'payment_mode': this.formData.setting.payment_mode,
        'is_cust_num': this.formData.is_cust_num,
        'allow_multi': this.formData.allow_multi,
        'add_type': this.formData.add_type,
        'branch_platform': this.formData.branch_platform,
        'has_upgrade': this.upOptData ? this.upOptData.length !== 0 : false,
        'setting': this.getSetting('reschedule'),
        'fb_setting': this.getSetting('fb_reschedule'),
        'is_yc': this.isYCMode
      }).then((res) => {
        this.rescheduleRes = res.data.reschedule_rules
        this.fbRescheduleRes = res.data.fb_reschedule_rules
      }).catch(err => {
        console.log(err)
      })
    }, 1000),
    onApply (r) {
      this.formData.cooling_off = r.coolingOff
      this.formData.no_show_penalty = r.no_show_penalty
      this.formData.cancelable = r.cancelable
      this.formData.fb_cancel_type = 0
      this.formData.reschedulable = r.reschedulable
      if (r.cancel_rule) {
        this.$set(this.formData, 'cancel_rule', r.cancel_rule)
      }

      this.$refs.cancelSetting.apply(r.cancel)
      this.$refs.rescheduleSetting.apply(r.reschedule)

      this.$nextTick(() => {
        if (this.transData) {
          for (let i = 0; i < this.transData.length; ++i) {
            let id = this.transData[i].lang_id
            if (r.trans && typeof r.trans[id] !== 'undefined') {
              this.$set(this.transData[i], 'cancel_rule', r.trans[id])
              this.$set(this.transData[i], 'cancel_rule_status', 1)
            }
          }
        }
      })
    },
    onCopy () {
      this.$confirm(
        this.$t('api.product.fields.cancel_rule.copy.confirm_msg'),
        this.$t('api.product.fields.cancel_rule.copy.confirm_title'),
        {
          confirmButtonText: this.$t('api.confirmBtn'),
          cancelButtonText: this.$t('api.cancelBtn'),
          type: 'warning'
        }).then(() => {
        this.formData.fb_cancelable = this.formData.cancelable
        this.formData.fb_reschedulable = this.formData.reschedulable
        this.formData.fb_cooling_off = this.formData.cooling_off
        this.$refs.fbCancelSetting.apply(this.$refs.cancelSetting.cancelRule)
        this.$refs.fbRescheduleSetting.apply(this.$refs.rescheduleSetting.rescheduleRule)
      }).catch(err => {
        console.log(err)
      })
    },
    preset (data) {
      if (data.cancel_setting) {
        this.$refs.cancelSetting.preset(data.cancel_setting)
      }
      if (data.fb_cancel_setting) {
        this.$refs.fbCancelSetting.preset(data.fb_cancel_setting)
      }
      if (data.reschedule_setting) {
        this.$refs.rescheduleSetting.preset(data.reschedule_setting)
      }
      if (data.fb_reschedule_setting) {
        this.$refs.fbRescheduleSetting.preset(data.fb_reschedule_setting)
      }
      this.onChange()
    },
    focusShowOnTypeBtn (v) {
      this.cancelRulePlatformBtnType = v
    },
    getGrammarConfig (name) {
      return {
        content: this.formData[name],
        template: GrammarCheckerTemplate.FunnowSupplementaryRules,
        currencyCode: this.formData.currency_code
      }
    }
  },
  watch: {
    '$store.getters.language' () {
      this.onChange()
      this.initDefRules()
    },
    'upOptData' () {
      this.onRescheduleChange()
    },
    'formData.is_cust_num' () {
      this.onRescheduleChange()
    },
    'formData.allow_multi' () {
      this.onRescheduleChange()
    },
    'formData.add_type' () {
      this.onRescheduleChange()
    },
    'formData.branch_platform' () {
      this.onRescheduleChange()
    },
    'formData.cancel_type' (v) {
      if (v !== 2) {
        this.formData.fb_cancel_type = 0
      }
      this.onCancelChange()
    },
    'formData.fb_cancel_type' () {
      this.onCancelChange()
    },
    'formData.cancelable' (v) {
      this.onCancelChange()
      if (v === 0) {
        this.formData.cooling_off = ProductCoolingOff.Disabled
        this.formData.no_show_penalty = ProductNoShowPenalty.Disabled
      }
    },
    'formData.fb_cancelable' (v) {
      this.onCancelChange()
      if (v === 0) {
        this.formData.fb_cooling_off = ProductCoolingOff.Disabled
        this.formData.fb_no_show_penalty = ProductNoShowPenalty.Disabled
      }
    },
    'formData.reschedulable' () {
      this.onRescheduleChange()
    },
    'formData.fb_reschedulable' () {
      this.onRescheduleChange()
    },
    'formData.setting.booking_mode' () {
      if (!this.isSeatOnlyAndPayOnsite) {
        this.formData.no_show_penalty = ProductNoShowPenalty.Disabled
        this.formData.fb_no_show_penalty = ProductNoShowPenalty.Disabled
        if (!this.isYCMode) {
          this.$refs.fbCancelSetting.adjustRuleMode()
          this.$refs.cancelSetting.adjustRuleMode()
        }
      } else {
        this.$refs.fbCancelSetting.leaveOneRule()
        this.$refs.cancelSetting.leaveOneRule()
      }
      this.onChange()
    },
    'formData.setting.payment_mode' () {
      if (this.isFunBookWithoutOnlinePayment) {
        this.$refs.fbCancelSetting.leaveOneRule()
        this.formData.fb_cancel_type = 1
      } else if (this.isFunBookOnlinePayment) {
        this.$refs.fbCancelSetting.adjustRuleMode()
      }
      this.onChange()
    },
    'formData.no_show_penalty' () {
      if (this.formData.no_show_penalty === ProductNoShowPenalty.Disabled && this.isSeatOnlyAndPayOnsite) {
        this.$refs.cancelSetting.leaveOneRule()
      }
      this.onChange()
    },
    'formData.show_on' (v) {
      switch (v) {
        case 0:
          this.cancelRulePlatformBtnType = this.platformBtnFocusType.notFocus
          break
        case 1:
          if (this.isFunBookV2Enable) {
            this.formData.fb_cancel_type = 1
            this.cancelRulePlatformBtnType = this.platformBtnFocusType.notFocus
          }
          break
        case 2:
          if (this.formData.cancel_type !== 2) {
            this.formData.fb_cancel_type = 0
          }
          this.cancelRulePlatformBtnType = this.platformBtnFocusType.funnow
          break
      }
    }
  }
}
</script>
